import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

export interface GetPaginatedResponsesInput {
  questionId: number;
  page: number;
}

export interface PaginatedResponsesResult {
  paginatedResponses: {
    questionId: number;
    total: number;
    responses: Array<Record<string, any>>;
    pages: number;
    feedbackSummary?: {
      summary: string;
      id: string;
      createdAt: string;
      updatedAt: string;
    };
  };
}

const getPaginatedResponsesQuery = gql`
  query paginatedResponses($questionId: Int!, $page: Int!) {
    paginatedResponses(questionId: $questionId, page: $page) {
      questionId
      total
      responses
      pages
      feedbackSummary {
        summary
        id
        createdAt
        updatedAt
      }
    }
  }
`;

export const getPaginatedResponses = (
  input: GetPaginatedResponsesInput
): Promise<PaginatedResponsesResult> => {
  return gqlClient.request<PaginatedResponsesResult>(getPaginatedResponsesQuery, input);
};
